/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    object, string, shape, arrayOf, number, func,

} from 'prop-types';
import { withRouter } from 'react-router';
import { compose } from 'recompose';
import withStyles from '@material-ui/core/styles/withStyles';
import { UIDReset, UIDConsumer } from 'react-uid';
import { decode as htmlDecode } from '../../../../../pages/Account/utils/htmlEntity';
import RedirectToSku from '../common/RedirectToSku';
import { selectedSkuType } from '../common/types';

const styles = (theme) => ({
    heading: {
        textTransform: 'uppercase',
        margin: '10px 4px 10px',
        fontSize: '0.9em',
        fontWeight: 'bold',
    },
    skusCard: {
        width: '50%',
        margin: '0 0 20px 0',
        cursor: 'pointer',
        '& img': {
            width: '100%',
        },
        background: theme.palette.white,
        border: 'none',
    },
    skusContent: {
        textAlign: 'center',
    },
    skusTitle: {
        color: theme.palette.black,
        minHeight: '25px',
        margin: '6px 12px 4px',
        overflow: 'hidden',
        fontSize: '1.2em',
        maxHeight: '40px',
        lineHeight: '1',
        display: '-webkit-box',
        '-webkit-box-orient': 'vertical',
        '-webkit-line-clamp': '2',
    },
    skuLabelAmount: {
        color: theme.palette.cms?.skuLabelAmountColor,
        fontSize: '1.2em',
        textAlign: 'center',
        fontWeight: '700',
    },
    crossedOutRetailPrice: {
        textDecoration: 'line-through',
        color: theme.palette.contentColor,
    },
    salePrice: {
        color: theme.palette.primaryButton,
        margin: '0 0 0 10px',
    },
    selectedSalePrice: {
        fontWeight: 'bold',
    },
    discountAmount: {
        color: theme.palette.cms?.skuPriceDiscountColor,
        fontWeight: 'normal',
        marginLeft: '10px',
        fontSize: '0.8em',
    },
    selectedRetailPrice: {
        fontWeight: 'bold',
        color: theme.palette.common?.black,
        fontSize: '0.9em',
    },
    retailPrice: {
        fontSize: '0.9em',
        color: theme.palette.common?.black,
    },
});
const renderSkuPrice = (sku, classes, clubPrice = false) => {
    const round = (value) => Number(`${Math.round(value * 10) / 10}`).toFixed(2);
    const priceNonSelected = clubPrice ? classes.clubPrice : classes.retailPrice;
    if (sku?.prices?.[0] && sku?.prices?.[1]) {
        return sku.prices[0].value > sku.prices[1].value
            ? (
                <>
                    <span className={classes.crossedOutRetailPrice}>
                        ${sku.prices[0].value}
                    </span>
                    <span className={`${classes.salePrice} ${classes.selectedSalePrice}`}>
                        ${sku.prices[1].value}
                    </span>
                    <span className={classes.discountAmount}>
                        ${round(sku.prices[0].value - sku.prices[1].value)} Off
                    </span>
                </>
            )
            : (
                <span className={priceNonSelected}>
                    ${sku.prices[0].value}
                </span>
            );
    }
    return null;
};
const GoDeluxe = ({
    classes,
    handleSkuChange,
    goDeluxeUpsells,
    selectedSku,
}) => (
    <RedirectToSku
        selectedSkuId={selectedSku?.id}
        onChange={handleSkuChange}
    >
        {({ redirectToSku }) => (
            <>
                <div className={classes.heading}>Go Deluxe</div>
                <UIDReset>
                    <UIDConsumer>
                        {(id, uid) => goDeluxeUpsells.map((sku) => (
                            <button type="button" className={classes.skusCard} key={`skus${uid(sku.name)}`} onClick={(e) => redirectToSku(e, sku)}>
                                <img src={`${sku.image?.path}${sku.image?.name}x.jpg`} alt={sku.name} />
                                <div className={classes.skusContent}>
                                    <p className={classes.skusTitle}>{htmlDecode(sku.name)}</p>
                                    <div className={classes.skuLabelAmount}>{renderSkuPrice(sku, classes)}</div>
                                </div>
                            </button>
                        ))}
                    </UIDConsumer>
                </UIDReset>
            </>
        )}
    </RedirectToSku>
);

GoDeluxe.propTypes = {
    classes: object.isRequired,
    goDeluxeUpsells: arrayOf(
        shape({
            id: string.isRequired,
            name: string.isRequired,
            prices: arrayOf(
                shape({
                    type: string.isRequired,
                    value: number.isRequired,
                    __typename: string.isRequired,
                }),
            ).isRequired,
            __typename: string.isRequired,
        }),
    ).isRequired,
    handleSkuChange: func.isRequired,
    selectedSku: selectedSkuType,
};

GoDeluxe.defaultProps = {
    selectedSku: {},
};
const enhance = compose(
    withStyles(styles),
    withRouter,
);

export default enhance(GoDeluxe);
